import { useState, useEffect } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "./firebase";
import GlobalStyles from "./components/GlobalStyles";
import Landing from "./pages/Landing";
import Setup from "./pages/Setup";
import Trial from "./pages/Trial";
import Evaluation from "./pages/Evaluation";
import { D } from "./constants";

export default function App() {
  const [user,         setUser]         = useState(undefined); // undefined = loading
  const [screen,       setScreen]       = useState("setup");
  const [cfg,          setCfg]          = useState(null);
  const [trialMsgs,    setTrialMsgs]    = useState([]);
  const [sessionCount, setSessionCount] = useState(
    () => parseInt(localStorage.getItem("ll_sessions") || "0", 10)
  );

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, u => setUser(u || null));
    return unsub;
  }, []);

  const handleSignOut = async () => {
    await signOut(auth);
    setUser(null); setCfg(null); setScreen("setup"); setTrialMsgs([]);
  };

  const handleStart = c => {
    setCfg(c); setTrialMsgs([]);
    setSessionCount(s => {
      const n = s + 1;
      localStorage.setItem("ll_sessions", n);
      return n;
    });
    setScreen("trial");
  };

  // Loading splash
  if (user === undefined) return (
    <div style={{ height:"100vh", background:D.bg, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:22 }}>
      <GlobalStyles/>
      <h1 style={{ fontFamily:"'Playfair Display',serif", fontWeight:900, fontSize:48, color:D.text }}>
        Litis<span style={{ color:D.gold }}>Lab</span>
      </h1>
      <div style={{ width:26, height:26, border:`3px solid ${D.borderMid}`, borderTopColor:D.gold, borderRadius:"50%", animation:"spin .8s linear infinite" }}/>
    </div>
  );

  // Not logged in
  if (!user) return <Landing onAuth={u => setUser(u)}/>;

  // Logged in — route between screens
  return (
    <>
      {screen === "setup" && (
        <Setup user={user} onStart={handleStart} onSignOut={handleSignOut}/>
      )}
      {screen === "trial" && cfg && (
        <Trial
          cfg={cfg}
          onEval={msgs => { setTrialMsgs(msgs || []); setScreen("eval"); }}
          onBack={() => { setCfg(null); setScreen("setup"); }}
          showTutorial={sessionCount <= 2}
        />
      )}
      {screen === "eval" && (
        <Evaluation
          cfg={cfg}
          msgs={trialMsgs}
          onRestart={() => { setCfg(null); setScreen("setup"); }}
        />
      )}
    </>
  );
}
